import { AWS_AUTH_TYPES } from "../../common/aws/AWSAuthenticationTypes";
export const toAWSSecurityLakeInputCreateRequest = ({
  awsSecurityLakeName,
  awsAuthenticationType,
  awsSecurityLakeStoreFullMessage,
  awsSecurityLakeThrottleEnabled,
  pollingInterval,
  awsAccessKey,
  awsSecretKey,
  securityLakeSqsQueueName,
  securityLakeRegion,
  key,
  secret,
  assumeRoleArn,
  awsExternalId,
  sqsMessageBatchSize
}) => ({
  name: awsSecurityLakeName.value,
  ...(awsAuthenticationType == null ? void 0 : awsAuthenticationType.value) === AWS_AUTH_TYPES.keysecret ? {
    aws_access_key: awsAccessKey == null ? void 0 : awsAccessKey.value,
    aws_secret_key: awsSecretKey == null ? void 0 : awsSecretKey.value
  } : {
    aws_access_key: key,
    aws_secret_key: secret
  },
  polling_interval: pollingInterval.value,
  polling_time_unit: "MINUTES",
  store_full_message: !!(awsSecurityLakeStoreFullMessage == null ? void 0 : awsSecurityLakeStoreFullMessage.value),
  enable_throttling: !!(awsSecurityLakeThrottleEnabled == null ? void 0 : awsSecurityLakeThrottleEnabled.value),
  security_lake_queue_name: securityLakeSqsQueueName.value,
  aws_region: securityLakeRegion.value,
  assume_role_arn: assumeRoleArn == null ? void 0 : assumeRoleArn.value,
  aws_external_id: awsExternalId == null ? void 0 : awsExternalId.value,
  sqs_message_batch_size: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value
});
export const toGenericInputCreateRequest = ({
  awsSecurityLakeName,
  awsAuthenticationType,
  awsSecurityLakeStoreFullMessage,
  awsSecurityLakeThrottleEnabled,
  awsAccessKey,
  awsSecretKey,
  pollingInterval,
  securityLakeSqsQueueName,
  securityLakeRegion,
  key,
  secret,
  assumeRoleArn,
  awsExternalId,
  sqsMessageBatchSize
}) => ({
  type: "org.graylog.enterprise.integrations.awssecuritylake.SecurityLakeInput",
  title: awsSecurityLakeName.value,
  global: false,
  configuration: {
    ...(awsAuthenticationType == null ? void 0 : awsAuthenticationType.value) === AWS_AUTH_TYPES.keysecret ? {
      aws_access_key: awsAccessKey == null ? void 0 : awsAccessKey.value,
      aws_secret_key: awsSecretKey == null ? void 0 : awsSecretKey.value
    } : {
      aws_access_key: key,
      aws_secret_key: secret
    },
    polling_interval: pollingInterval.value,
    polling_time_unit: "MINUTES",
    store_full_message: !!(awsSecurityLakeStoreFullMessage == null ? void 0 : awsSecurityLakeStoreFullMessage.value),
    throttling_allowed: !!(awsSecurityLakeThrottleEnabled == null ? void 0 : awsSecurityLakeThrottleEnabled.value),
    security_lake_queue_name: securityLakeSqsQueueName.value,
    aws_region: securityLakeRegion.value,
    assume_role_arn: assumeRoleArn == null ? void 0 : assumeRoleArn.value,
    aws_external_id: awsExternalId == null ? void 0 : awsExternalId.value,
    sqs_message_batch_size: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value
  }
});
